/** Multiply EUR by these to get approximate local amounts (update manually). */
export const ICAGILE_FX_FROM_EUR = {
    USD: 1.08,
    RUB: 98,
};
const TAG_AI_LEADERS = [
    "ai",
    "ии",
    "искусствен",
    "лидер",
    "leader",
    "руковод",
    "стратег",
    "strategy",
    "иннова",
    "innovat",
    "продуктивн",
    "automation",
    "автоматиз",
    "цифров",
    "digital",
    "видени",
    "vision",
    "трансформ",
    "transform",
];
const TAG_APM = [
    "проект",
    "project",
    "управлен",
    "management",
    "планирован",
    "planning",
    "роадмап",
    "roadmap",
    "релиз",
    "release",
    "milestone",
    "оценк",
    "estimat",
    "риск",
    "risk",
    "зависимост",
    "dependenc",
    "бюджет",
    "budget",
    "поставк",
    "delivery",
    "отчёт",
    "report",
    "критери",
    "criteria",
    "dor",
    "dod",
];
const TAG_SCALING = [
    "масштаб",
    "scaling",
    "scale",
    "safe",
    "less",
    "несколько команд",
    "координац",
    "coordination",
    "кросс",
    "cross",
    "программ",
    "program",
    "портфел",
    "portfolio",
    "синхрон",
    "synchron",
    "артефакт",
    "artifact",
    "трейн",
    "train",
    "agile release",
    "стратегич",
];
const TAG_TEAM_PERFORMANCE = [
    "команд",
    "team",
    "вовлеч",
    "engagement",
    "коммуникац",
    "communication",
    "конфликт",
    "conflict",
    "ретроспект",
    "retrospective",
    "обратн",
    "feedback",
    "культура",
    "culture",
    "доверие",
    "trust",
    "самоорган",
    "self-organ",
    "автоном",
    "autonom",
    "психолог",
    "psycholog",
    "мотивац",
    "motivation",
    "лидер",
    "leadership",
    "коуч",
    "coach",
    "perform",
    "людьми",
    "people",
];
const TAG_CERT_AGILE_PRO = [
    "agile",
    "scrum",
    "канбан",
    "kanban",
    "церемон",
    "ceremon",
    "ритм",
    "cadence",
    "ретроспект",
    "retrospective",
    "дейли",
    "daily",
    "демо",
    "demo",
    "спринт",
    "sprint",
    "инкремент",
    "increment",
    "прозрачн",
    "transparency",
    "мышлен",
    "mindset",
    "фундамент",
    "foundation",
    "principles",
    "принцип",
    "values",
    "ценност",
    "icp",
    "professional",
    "обучен",
    "learning",
];
const TAG_PRODUCT_MGMT = [
    "продукт",
    "product",
    "бэклог",
    "backlog",
    "приорит",
    "priorit",
    "story",
    "user story",
    "ценност",
    "value",
    "roadmap",
    "стейкхолдер",
    "stakeholder",
    "владелец",
    "owner",
    "бизнес",
    "business",
    "требован",
    "requirement",
    "вертикальн",
    "vertical",
    "discovery",
    "бизнес-ценност",
    "outcome",
    "kpi",
    "north star",
    "po",
    "apo",
];
export const ICAGILE_PROGRAMS = [
    {
        id: "ai-for-leaders",
        titleRu: "AI for Leaders",
        titleEn: "AI for Leaders",
        pitchRu: "Лидерская программа о том, как встроить AI в продукт и команду без потери управляемости.",
        pitchEn: "Leadership programme on embedding AI into product and team without losing control.",
        outcomesRu: [
            "Стратегические сценарии применения AI в командах",
            "Практики безопасного внедрения и метрики эффекта",
            "Готовый план первых 90 дней по AI-инициативе",
        ],
        outcomesEn: [
            "Strategic AI use cases for teams",
            "Safe-rollout practices and effect metrics",
            "Ready 90-day plan for an AI initiative",
        ],
        basePriceEur: 2200,
        internalUrl: "https://onagile.ru/trainings/ai-for-leaders/",
        matchTags: TAG_AI_LEADERS,
    },
    {
        id: "agile-project-management",
        titleRu: "Agile Project Management",
        titleEn: "Agile Project Management",
        pitchRu: "Системные практики управления проектом в условиях частых изменений и зависимостей.",
        pitchEn: "Project-management practices for environments with frequent change and dependencies.",
        outcomesRu: [
            "Скоупинг, оценка и управление рисками без излишней бюрократии",
            "Управление зависимостями и заинтересованными сторонами",
            "Прозрачные релизы и предсказуемая поставка",
        ],
        outcomesEn: [
            "Scoping, estimation and risk management without bureaucracy",
            "Managing dependencies and stakeholders",
            "Transparent releases and predictable delivery",
        ],
        basePriceEur: 1900,
        internalUrl: "https://onagile.ru/trainings/agile-project-management/",
        matchTags: TAG_APM,
    },
    {
        id: "scaling-agile-safe-less",
        titleRu: "Scaling Agile (SAFe / LeSS)",
        titleEn: "Scaling Agile (SAFe / LeSS)",
        pitchRu: "Когда одной команды уже мало — как синхронизировать несколько команд без бутылочных горлышек.",
        pitchEn: "When one team is not enough — how to synchronise multiple teams without bottlenecks.",
        outcomesRu: [
            "Выбор подходящего фреймворка масштабирования (SAFe vs LeSS)",
            "Практики PI-планирования и кросс-командной координации",
            "Снятие зависимостей и снижение «налога на масштаб»",
        ],
        outcomesEn: [
            "Choosing the right scaling framework (SAFe vs LeSS)",
            "PI planning and cross-team coordination practices",
            "Removing dependencies and reducing scaling overhead",
        ],
        basePriceEur: 2100,
        internalUrl: "https://onagile.ru/trainings/scaling-agile-safe-less/",
        matchTags: TAG_SCALING,
    },
    {
        id: "team-performance",
        titleRu: "Team Performance",
        titleEn: "Team Performance",
        pitchRu: "Как поднять предсказуемость и атмосферу в команде через измеримые практики.",
        pitchEn: "How to lift team predictability and culture through measurable practices.",
        outcomesRu: [
            "Диагностика текущей зрелости и точек роста команды",
            "Практики рабочих ретро, конфликтов и обратной связи",
            "Измеримые показатели улучшения за квартал",
        ],
        outcomesEn: [
            "Diagnostics of current team maturity and growth points",
            "Practices for retros, conflict and feedback",
            "Measurable improvement KPIs in a quarter",
        ],
        basePriceEur: 1800,
        internalUrl: "https://onagile.ru/trainings/team-performance/",
        matchTags: TAG_TEAM_PERFORMANCE,
    },
    {
        id: "certified-agile-professional",
        titleRu: "Certified Agile Professional",
        titleEn: "Certified Agile Professional",
        pitchRu: "Базовый сертификационный курс — единый язык, ценности и принципы Agile для всей команды.",
        pitchEn: "Foundational certified course — shared language, values and principles for the whole team.",
        outcomesRu: [
            "Единое понимание ценностей, принципов и практик Agile",
            "Базовые ритуалы Scrum/Kanban и работа с артефактами",
            "Сертификат о прохождении программы",
        ],
        outcomesEn: [
            "Shared understanding of Agile values, principles and practices",
            "Foundational Scrum/Kanban rituals and artefacts",
            "Certificate of completion",
        ],
        basePriceEur: 1850,
        internalUrl: "https://onagile.ru/trainings/certified-agile-professional/",
        matchTags: TAG_CERT_AGILE_PRO,
    },
    {
        id: "agile-product-management",
        titleRu: "Agile Product Management",
        titleEn: "Agile Product Management",
        pitchRu: "Для PO/PM: формулирование ценности, бэклога и измеримых результатов продукта.",
        pitchEn: "For PO/PM: articulating value, backlog and measurable product outcomes.",
        outcomesRu: [
            "Discovery, формулирование гипотез и метрик продукта",
            "Приоритизация бэклога и работа со стейкхолдерами",
            "Связка стратегии с поставкой через outcome-роадмап",
        ],
        outcomesEn: [
            "Discovery, hypothesis framing and product metrics",
            "Backlog prioritisation and stakeholder management",
            "Linking strategy to delivery through an outcome roadmap",
        ],
        basePriceEur: 1950,
        internalUrl: "https://onagile.ru/trainings/agile-product-management/",
        matchTags: TAG_PRODUCT_MGMT,
    },
];
function normalizeMatchBlob(parts) {
    return parts.join(" ").toLowerCase();
}
/**
 * Uses category / subcategory labels from the results payload and picks 1–3 programs.
 * Weak areas: category average < threshold; if none, lowest averages are used.
 * With minPrograms, pads from the next-best scored programs so the UI can always show pairs.
 */
export function pickIcagileProgramsForResults(results, options) {
    const weakThreshold = options?.weakThreshold ?? 3;
    const maxPrograms = options?.maxPrograms ?? 3;
    const minPrograms = Math.min(options?.minPrograms ?? 1, maxPrograms);
    const categoryEntries = Object.entries(results).filter(([, subs]) => subs && typeof subs === "object" && Object.keys(subs).length > 0);
    if (categoryEntries.length === 0) {
        return [];
    }
    const avgs = [];
    for (const [cat, subs] of categoryEntries) {
        const vals = Object.values(subs).map((v) => Number(v) || 0);
        const avg = vals.reduce((a, b) => a + b, 0) / vals.length;
        avgs.push({ name: cat, avg });
    }
    let weak = avgs.filter((c) => c.avg < weakThreshold);
    if (weak.length === 0) {
        weak = [...avgs].sort((a, b) => a.avg - b.avg).slice(0, Math.min(3, avgs.length));
    }
    const blobParts = [];
    for (const c of weak) {
        blobParts.push(c.name);
        const subs = results[c.name];
        if (subs)
            blobParts.push(...Object.keys(subs));
    }
    const blob = normalizeMatchBlob(blobParts);
    const fallback = ICAGILE_PROGRAMS.find((p) => p.id === "certified-agile-professional");
    if (!fallback)
        return [];
    const scored = ICAGILE_PROGRAMS.map((p) => ({
        p,
        score: p.matchTags.reduce((acc, tag) => {
            const t = tag.toLowerCase();
            if (!t)
                return acc;
            return acc + (blob.includes(t) ? 1 : 0);
        }, 0),
    })).sort((a, b) => b.score - a.score || a.p.titleRu.localeCompare(b.p.titleRu));
    const withHits = scored.filter((s) => s.score > 0);
    if (withHits.length === 0) {
        if (minPrograms <= 1 && maxPrograms <= 1) {
            return [fallback];
        }
        const picked = [fallback];
        const seen = new Set([fallback.id]);
        for (const { p } of scored) {
            if (picked.length >= maxPrograms)
                break;
            if (!seen.has(p.id)) {
                seen.add(p.id);
                picked.push(p);
            }
        }
        return picked.slice(0, maxPrograms);
    }
    const picked = [];
    const seen = new Set();
    for (const { p, score } of withHits) {
        if (picked.length >= maxPrograms)
            break;
        if (score > 0 && !seen.has(p.id)) {
            seen.add(p.id);
            picked.push(p);
        }
    }
    if (picked.length < minPrograms) {
        for (const { p } of scored) {
            if (picked.length >= maxPrograms)
                break;
            if (!seen.has(p.id)) {
                seen.add(p.id);
                picked.push(p);
            }
        }
    }
    return picked.length > 0 ? picked.slice(0, maxPrograms) : [fallback];
}
